import React, { Component } from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { JiraSupport } from './JiraSupport'; // Importa JiraSupport
import '../../../../style/components/support-options.less';
import { arrowBottomIcon, arrowRightIcon1, arrowTopIcon, HelpCircle, Reports, VectorArrowRightIconNew } from '../../../../style/images';
import { Drawer, Link, IconButton as MuiIconButton } from '@mui/material';
import { translate } from '../../../services';

export class SupportOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSupport: false,
            activeAccordion: null
        };
    }

    toggleSupport = () => {
        this.setState({ showSupport: !this.state.showSupport });
    };


    handleAccordionClick = (index) => {
        this.setState((prevState) => ({
            activeAccordion: prevState.activeAccordion === index ? null : index,
        }));
    };

    render() {
        const { activeAccordion } = this.state;
        
        return (
            <Box className="support-options-wrapper">
                <Typography className="red-icon"></Typography>
                <Typography className="section-title">{translate('SupportPage.Title')}</Typography>
                <div className="accordion-FAQ">
                <Typography className="section-subtitle">
                    <MuiIconButton width="32px" height="32px" sx={{ right: '10px', background: "transparent", height: "32px", width: "32px", borderRadius: "56px" }}>
                        <Box component="img" style={{ width: "inherit", height: "inherit" }} src={HelpCircle}></Box>
                    </MuiIconButton>
                    
                FAQ</Typography> 
                <Box className="support-options-section">
                    <div className="accordion-FAQ">
                        <div className="accordion-item">
                            <button className="accordion-header" onClick={() => this.handleAccordionClick(0)}>
                                <MuiIconButton width="18px" height="18px" sx={{ right: '10px', background: "transparent", height: "18px", width: "18px", borderRadius: "56px" }}>
                                    <Box component="img" style={{ width: "inherit", height: "inherit" }} src={activeAccordion === 0 ? arrowTopIcon : arrowBottomIcon}></Box>
                                </MuiIconButton>
                                <div>What information is needed to use the configurator tool?</div>
                            </button>
                            <div className="accordion-content" style={{ display: activeAccordion === 0 ? 'block' : 'none' }}>
                                <p>Details about the configurator tool...</p>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <button className="accordion-header" onClick={() => this.handleAccordionClick(1)}>
                                <MuiIconButton width="18px" height="18px" sx={{ right: '10px', background: "transparent", height: "18px", width: "18px", borderRadius: "56px" }}>
                                    <Box component="img" style={{ width: "inherit", height: "inherit" }} src={activeAccordion === 1 ? arrowTopIcon : arrowBottomIcon}></Box>
                                </MuiIconButton>
                                <div>What information is needed to use the configurator tool?</div>
                            </button>
                            <div className="accordion-content" style={{ display: activeAccordion === 1 ? 'block' : 'none' }}>
                                <p>Details about the configurator tool...</p>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <button className="accordion-header" onClick={() => this.handleAccordionClick(2)}>
                                <MuiIconButton width="18px" height="18px" sx={{ right: '10px', background: "transparent", height: "18px", width: "18px", borderRadius: "56px" }}>
                                    <Box component="img" style={{ width: "inherit", height: "inherit" }} src={activeAccordion === 2 ? arrowTopIcon : arrowBottomIcon}></Box>
                                </MuiIconButton>
                                <div>What information is needed to use the configurator tool?</div>
                            </button>
                            <div className="accordion-content" style={{ display: activeAccordion === 2 ? 'block' : 'none' }}>
                                <p>Details about the configurator tool...</p>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <button className="accordion-header" onClick={() => this.handleAccordionClick(3)}>
                                <MuiIconButton width="18px" height="18px" sx={{ right: '10px', background: "transparent", height: "18px", width: "18px", borderRadius: "56px" }}>
                                    <Box component="img" style={{ width: "inherit", height: "inherit" }} src={activeAccordion === 3 ? arrowTopIcon : arrowBottomIcon}></Box>
                                </MuiIconButton>
                                <div>What information is needed to use the configurator tool?</div>
                            </button>
                            <div className="accordion-content" style={{ display: activeAccordion === 3 ? 'block' : 'none' }}>
                                <p>Details about the configurator tool...</p>
                            </div>
                        </div>
                    </div>
                    
                </Box>
                </div> 
                
                <Typography className="section-subtitle">
                    <MuiIconButton width="32px" height="32px" sx={{ right: '10px', background: "transparent", height: "32px", width: "32px", borderRadius: "56px" }}>
                        <Box component="img" style={{ width: "inherit", height: "inherit" }} src={Reports}></Box>
                    </MuiIconButton>
                    
                    {translate('SupportPage.SupportTitle')}</Typography> 
                <Box className="support-options-section">
                    <Box className="support-options-subtitle">
                        <Typography className="option">{translate('SupportPage.SupportSubTitle')}</Typography>
                        <Typography className="option">
                        {translate('SupportPage.ChangeRequest1')}<span className="change-request"> {translate('SupportPage.ChangeRequestBold')}</span>{translate('SupportPage.ChangeRequest2')} 
                            <Link href="mailto:it.support.econfiguredevices@abb.com" className="custom-link"> it.support.econfiguredevices@abb.com</Link>
                        </Typography>
                    </Box>
                    <Box className="support-options-list">
                        <Typography className="option with-dot">{translate('SupportPage.Dot1')}</Typography>
                        <span className="red-dot"></span>
                        <Typography className="option with-dot">{translate('SupportPage.Dot2')}</Typography>
                        <span className="red-dot"></span>
                        <Typography className="option with-dot">{translate('SupportPage.Dot3')}</Typography>
                        <span className="red-dot"></span>
                        <Typography className="option with-dot">{translate('SupportPage.Dot4')}</Typography>
                        <span className="red-dot"></span>
                        <Typography className="option with-dot">{translate('SupportPage.Dot5')}</Typography>
                        <span className="red-dot"></span>
                        <Typography className="option with-dot">{translate('SupportPage.Dot6')}</Typography>
                    </Box>
                    <div style={{alignSelf:"flex-end"}}>
                        <JiraSupport />
                    </div>
                </Box>
                             
                {/* <Typography className="section-subtitle">Feedback form</Typography>
                <Box className="support-options-section">
                    <Box className="support-options-subtitle">
                        <Typography className="option">If you’re experiencing any technical issues or errors with our product or service, please use this form to report the problem. Our technical support team will review your submission and respond with assistance as soon as possible.</Typography>
                    </Box>
                    <Box className="support-options-list">
                        <Typography className="option with-dot">General Support Inquiries</Typography>
                        <Typography className="option with-dot">Product or Service Information</Typography>
                    </Box>
                    <Button className="support-button" disabled>
                        Feedback form
                    </Button>
                </Box> */}
            </Box>
        );
    }
}

SupportOptions.propTypes = {
    toggleSupport: PropTypes.func.isRequired,
};

export default SupportOptions;
